import * as RNLocalize from 'react-native-localize';

export const isRestricted = (coutries: string[] = []): boolean => {
  if (!coutries.length) {
    return false;
  }
  const userCountry = RNLocalize.getCountry();
  return coutries.includes(userCountry);
};
